var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "notification-icon-alert.14dde337.png","uri@2x": __webpack_public_path__ + "notification-icon-alert.8b5111eb.png","uri@3x": __webpack_public_path__ + "notification-icon-alert.18043502.png",
    width: 24,
    height: 23
});